const addTogglePrevNextBtnsActive = (emblaApi, prevBtn, nextBtn) => {
    const togglePrevNextBtnsState = () => {
        if (emblaApi.canScrollPrev()) prevBtn?.removeAttribute('disabled')
        else prevBtn?.setAttribute('disabled', 'disabled')

        if (emblaApi.canScrollNext()) nextBtn?.removeAttribute('disabled')
        else nextBtn?.setAttribute('disabled', 'disabled')
    }

    emblaApi
        .on('select', togglePrevNextBtnsState)
        .on('init', togglePrevNextBtnsState)
        .on('reInit', togglePrevNextBtnsState)

    return () => {
        prevBtn?.removeAttribute('disabled')
        nextBtn?.removeAttribute('disabled')
    }
}

export const addPrevNextBtnsClickHandlers = (
    emblaApi,
    prevBtn,
    nextBtn,
    onButtonClick
) => {
    const scrollPrev = () => {
        emblaApi.scrollPrev()
        if (onButtonClick) onButtonClick(emblaApi)
    }
    const scrollNext = () => {
        emblaApi.scrollNext()
        if (onButtonClick) onButtonClick(emblaApi)
    }
    prevBtn?.addEventListener('click', scrollPrev, false)
    nextBtn?.addEventListener('click', scrollNext, false)

    const removeTogglePrevNextBtnsActive = addTogglePrevNextBtnsActive(
        emblaApi,
        prevBtn,
        nextBtn
    )

    return () => {
        removeTogglePrevNextBtnsActive()
        prevBtn.removeEventListener('click', scrollPrev, false)
        nextBtn.removeEventListener('click', scrollNext, false)
    }
}

/*
* This function place the arrow buttons in the middle of the image
* Code example:
* let resizeProcessTimeOut;
        window.addEventListener('load', placeCarousedArrowButton);
        window.onresize = function () {
            clearTimeout(resizeProcessTimeOut);
            resizeProcessTimeOut = setTimeout(placeCarousedArrowButton, 500);
        };
* */
export function placeCarousedArrowButton() {
    // get the image from the DOM .embla__slide__number .home-lablife--img
    const emblaSlideNumber = document.querySelectorAll('.embla__slide__number .home-lablife--img');
    let maxHeight = 0;
    emblaSlideNumber.forEach((element) => {
        if (element.clientHeight > maxHeight) {
            maxHeight = element.clientHeight;
        }
    });
    const emblaButtons = document.querySelector('.embla__buttons');
    // place emblaButtons at the middle of maxHeight and using the middle of its size(emblaButtons), using margin top
    emblaButtons.style.marginTop = `${maxHeight / 2 - emblaButtons.clientHeight / 2}px`;
}
